import { useCallback } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import posthog from "posthog-js";

export type TrackingObject = {
  /** The name of the event to track. - eg: custom_event */
  event?: string;
  /** The category of the event - eg: my account*/
  eventCategory?: string;
  /** The action of the event - eg: click, visible*/
  eventAction?: string;
  /** The label of the event - eg: coming up*/
  eventLabel?: string;
};

/**
 * Custom hook to send tracking data to Google Tag Manager (GTM) and Posthog.
 */

export default function useSendDataForTracking() {
  const sendDataToGTM = useGTMDispatch();

  const sendTrackingData = useCallback(
    (TrackingObject: TrackingObject, eventName: string = "custom_event") => {
      sendDataToGTM(TrackingObject);

      posthog.capture(eventName, TrackingObject);
    },
    [sendDataToGTM]
  );

  return { sendTrackingData };
}
